export default "__VITE_ASSET__DwSAvSgc__"